import { useContext } from "react";
import AuthContext from "src/context/AuthContext";

export const useFileManagement = () => {
	const { clientConfiguration } = useContext(AuthContext);

	const getFileUrl = (fileName: string) => {
		return clientConfiguration
			? `${clientConfiguration.file_management_storage_account}/${fileName}`
			: fileName;
	};

	return {
		getFileUrl,
	};
};
